const timeout = r => require(['@/views/timeout.vue'], r) // 超时规则：首页
const whiteList = r => require(['@/views/whiteList/searchWhiteList.vue'], r) // 白名单：首页
const saveWhite = r => require(['@/views/whiteList/saveWhite.vue'], r) // 白名单：新建
const sortList = r => require(['@/views/whiteList/sortList.vue'], r) // 白名单：
const outTime = r => require(['@/views/outTime.vue'], r) // 已推送超时数据
const outTimeReady = r => require(['@/views/outTimeReady.vue'], r) // 待推送超时数据
const weekReport = r => require(['@/views/timeoutReminder/weekReport/weekReport.vue'], r) // 周报推送范围

export default [
  {
    path: 'timeout',
    component: timeout,
    name: 'timeout',
    meta: {
      keepAlive: true,
      name: '超时提醒'
    },
  },
  {
    path: 'whiteList',
    component: whiteList,
    name: 'whiteList',
    meta: {
      keepAlive: true,
      name: '超时提醒'
    },
  },
  {
    path: 'saveWhite',
    component: saveWhite,
    name: 'saveWhite',
    meta: {
      keepAlive: true,
      name: '超时提醒'
    },
  },
  {
    path: 'sortList',
    component: sortList,
    name: 'sortList',
    meta: {
      keepAlive: true,
      name: '超时提醒'
    },
  },
  {
    path: '/outTime',
    component: outTime,
    name: 'outTime',
    meta: {
      auth: true,
      name: '超时提醒'
    }
  },
  {
    path: '/outTimeReady',
    component: outTimeReady,
    name: 'outTimeReady',
    meta: {
      auth: true,
      name: '超时提醒'
    }
  },
  {
    path: 'weekReport',
    component: weekReport,
    name: 'weekReport',
    meta: {
      auth: true,
      name: '超时提醒'
    }
  },
]



// WEBPACK FOOTER //
// ./src/router/timeoutReminder.js